import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
    dashboardMenu,
    mastersMenu,
    outletsMenu,
    menu,
    contentMgtMenu,
    couponsMenu,
    systemMenu,
    automationMenu,
    CustomerSupportMgt,
    CancellationRequest,
    PurchaseMenu,
    reportsMenu,
    transactionsMenu,
    userLevelMenu,
    materialMgtMenu,
    assetMgtMenu,
    FranchiseEnquiryMenu,
    subscriptionMenu,
    summariesMenu,
    userMgtMenu,
    supportMenu,
    requestsIntendMenu,
    deliveryAppMenu,
    notificationsMenu
} from "../data/Menu";
import axiosInstance from "../api/axios";
import { updatePendingStockRequestsCount } from "../redux/actions/stockRequestActions";

class Sidebar extends Component {

    // componentDidMount() {
    //     this.fetchPendingCount();
    // }

    // fetchPendingCount = async () => {
    //     const accessToken = localStorage.getItem('authToken');
    //     if (!accessToken) return;

    //     try {
    //         const headers = { Authorization: `Bearer ${accessToken}` };
    //         const res = await axiosInstance.get('stock-requisition', { headers });
    //         const raw = res?.data?.data?.data ?? [];
    //         const formattedData = Array.isArray(raw) ? raw : [raw].filter(Boolean);

    //         const pendingCount = formattedData.filter(req => req.status === 'PENDING').length;
    //         this.props.dispatch(updatePendingStockRequestsCount(pendingCount));
    //     } catch (err) {
    //         console.error('Failed to fetch pending stock requests count:', err);
    //     }
    // };

    toggleFooterMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest(".sidebar");
        parent.classList.toggle("footer-menu-show");
    }

    render() {
        const { access, userEmail, pendingStockRequests } = this.props;
        // const userEmail = localStorage.getItem("email");
        console.log("Access or Permissions :", access, "user email :", userEmail);

        return (
            <div className="sidebar">
                <div className="sidebar-header">
                    <Link to="/dashboard" className="sidebar-logo">xpanse</Link>
                </div>
                <PerfectScrollbar className="sidebar-body pb-3" ref={ref => this._scrollBarRef = ref}>
                    <SidebarMenu
                        onUpdateSize={() => this._scrollBarRef.updateScroll()}
                        access={access}
                        userEmail={userEmail}
                        pendingStockRequests={pendingStockRequests} // Pass the count
                    />
                </PerfectScrollbar>
                <div className="sidebar-footer mt-2">
                    {/* <h6>Hello</h6> */}
                    ... footer content ...
                </div>
            </div>
        )
    }
}

class SidebarMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeGroup: null,
        };
    }

    // Debug method to log permissions and menu access
    debugPermissions = (categoryName, menuData) => {
        const { access } = this.props;
        console.log(`=== DEBUG: ${categoryName} ===`);
        console.log('User permissions:', access);

        menuData.forEach(menuItem => {
            const componentName = this.getComponentNameFromMenuItem(menuItem);
            const hasAccess = this.hasMenuItemAccess(menuItem);
            console.log(`Menu item: ${menuItem.label}, Component: ${componentName}, Has access: ${hasAccess}`);
        });
    }

    // Check if user has access to any component in a category
    hasCategoryAccess = (categoryName, menuData) => {
        const { access } = this.props;

        // If access is undefined or empty, show all categories
        if (!access || access.length === 0) {
            console.log(`No access restrictions, showing category: ${categoryName}`);
            return true;
        }

        // Check if any menu item in this category has access
        const hasAccess = menuData.some(menuItem => {
            return this.hasMenuItemAccess(menuItem);
        });

        console.log(`Category ${categoryName} access: ${hasAccess}`);

        // Debug output for outlets specifically
        if (categoryName === "Outlets") {
            this.debugPermissions(categoryName, menuData);
        }

        return hasAccess;
    };

    // Check if user has access to a specific menu item
    hasMenuItemAccess = (menuItem) => {
        const { access } = this.props;

        // If access is undefined or empty, show all menu items
        if (!access || access.length === 0) return true;

        const componentName = this.getComponentNameFromMenuItem(menuItem);

        // Special case: If it's "ALL REPORTS", check if user has ANY report permission
        if (componentName === "AllReports") {
            const hasReportAccess = access.some(permission => {
                const permComponentName = permission.split(':')[0].trim();
                // Check if this is any kind of report permission
                return permComponentName.endsWith('Report') ||
                    permComponentName.endsWith('Summary') ||
                    permComponentName.includes('Transaction');
            });
            return hasReportAccess;
        }

        // Check if user has any permission for this component (any action)
        const hasAccess = access.some(permission => {
            const permComponentName = permission.split(':')[0].trim();
            return permComponentName.toLowerCase() === componentName.toLowerCase();
        });

        return hasAccess;
    };

    // Get component name from menu item
    getComponentNameFromMenuItem = (menuItem) => {
        console.log("Menu Item :", menuItem);

        // First try to use the component property if it exists
        if (menuItem.component) {
            return menuItem.component;
        }


        // Convert menu label to proper component name format
        const label = menuItem.label.toLowerCase();

        // Special cases that don't follow simple conversion rules
        const specialCases = {
            "all reports": "AllReports",
            "outlet mgt": "Outlet",
            "outlet user mgt": "OutletUser",
            "kiosk user mgt": "KioskUser",
            "customer support mgt": "CustomerSupportMgt",
            "menu ingredients": "MenuIngredients",
            "addon group": "AddonGroup",
            "addon allocation": "AddonAllocation",

        };

        // Check if this is a special case
        if (specialCases[label]) {
            return specialCases[label];
        }

        // Default conversion: remove spaces and capitalize first letter of each word
        // Example: "category mgt" -> "CategoryMgt"
        const words = label.split(' ');
        const camelCaseWords = words.map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
        );

        return camelCaseWords.join('');
    };

    populateMenu = (menuItems) => {
        const { pendingStockRequests } = this.props;

        console.log("PendingStockRequests :", pendingStockRequests);


        // Filter menu items based on access
        const accessibleMenuItems = menuItems.filter(menuItem =>
            this.hasMenuItemAccess(menuItem)
        );

        // If no menu items are accessible, return null
        if (accessibleMenuItems.length === 0) {
            return null;
        }

        return (
            <ul className="nav nav-sidebar">
                {accessibleMenuItems.map((m, key) => {
                    const submenu = m.submenu?.map((sm, k) => (
                        <NavLink to={sm.link} className="nav-sub-link" key={k}>
                            {sm.label}
                        </NavLink>
                    ));

                    // Get badge count for this menu item
                    let badgeCount = 0;
                    console.log("m.badgeKey", m);

                    if (m.showBadge && m.label === 'STOCK REQUEST') {
                        badgeCount = pendingStockRequests;
                    }

                    return (
                        <li key={key} className="nav-item" style={{ fontSize: "12.5px" }}>
                            {!submenu ? (
                                <NavLink to={m.link} className="nav-link">
                                    <i style={{ fontSize: "17px" }} className={m.icon}></i> <span>{m.label}</span>
                                    {badgeCount > 0 && (
                                        <span
                                            style={{
                                                marginLeft: '8px',
                                                background: '#6366f1', // Indigo/Blue - matches your "List" button
                                                color: '#fff',
                                                borderRadius: '10px',
                                                padding: '2px 7px',
                                                fontSize: '10px',
                                                fontWeight: '700',
                                                minWidth: '18px',
                                                textAlign: 'center',
                                                display: 'inline-block'

                                            }}
                                        >
                                            {badgeCount}
                                        </span>
                                    )}
                                </NavLink>
                            ) : (
                                <div
                                    onClick={this.toggleSubMenu}
                                    className="nav-link has-sub"
                                >
                                    <i className={m.icon}></i> <span>{m.label}</span>
                                </div>
                            )}
                            {submenu && <nav className="nav nav-sub">{submenu}</nav>}
                        </li>
                    );
                })}
            </ul>
        );
    };

    toggleMenu = (menuName) => {
        this.setState(
            (prevState) => ({
                activeGroup: prevState.activeGroup === menuName ? null : menuName,
            }),
            () => this.props.onUpdateSize()
        );
    };

    toggleSubMenu = (e) => {
        e.preventDefault();
        const parent = e.target.closest(".nav-item");
        let node = parent.parentNode.firstChild;

        while (node) {
            if (node !== parent && node.nodeType === Node.ELEMENT_NODE) {
                node.classList.remove("show");
            }
            node = node.nextElementSibling || node.nextSibling;
        }

        parent.classList.toggle("show");
        this.props.onUpdateSize();
    };

    renderGroup = (label, menuData, nameKey) => {
        const { userEmail, pendingStockRequests } = this.props;

        // Hide "Requests Indent" for specific email
        if (label === "Requests Indent" && userEmail === "contact@xpansecafe.com") {
            console.log(`Hiding ${label} for email: ${userEmail}`);
            return null;
        }

        // Check if user has access to this category
        if (!this.hasCategoryAccess(label, menuData)) {
            return null;
        }

        // Calculate total badge count for this group
        let groupBadgeCount = 0;
        if (label === "Purchase") {
            groupBadgeCount = pendingStockRequests;
        }

        // If there's only one menu item, handle it as a direct link
        if (menuData.length === 1) {
            const singleMenuItem = menuData[0];
            // Check if user has access to this single menu item
            if (!this.hasMenuItemAccess(singleMenuItem)) {
                return null;
            }

            return (
                <div className="nav-group">
                    <NavLink
                        to={singleMenuItem.link}
                        className="nav-label"
                        style={{ fontWeight: "bolder", cursor: "pointer", fontSize: '10px' }}
                        activeClassName="active"
                    >
                        {label}
                    </NavLink>
                </div>
            );
        }

        // For multiple items, use the existing expandable group behavior
        const isOpen = this.state.activeGroup === nameKey;
        return (
            <div className={`nav-group ${isOpen ? "show" : ""}`} style={{ cursor: 'pointer' }}>
                <div
                    className="nav-label"
                    style={{ fontWeight: "bolder", fontSize: '10px' }}
                    onClick={() => this.toggleMenu(nameKey)}
                >
                    <span>{label}</span>
                    {groupBadgeCount > 0 && (
                        <span
                            style={{
                                background: '#6366f1', // Indigo/Blue - matches your "List" button
                                color: '#fff',
                                borderRadius: '10px',
                                padding: '2px 7px',
                                fontSize: '9px',
                                fontWeight: '700',
                                minWidth: '18px',
                                textAlign: 'center',
                                display: 'inline-block',
                                marginLeft: '110px',
                                boxShadow: '0 1px 3px rgba(245, 158, 11, 0.3)'
                            }}
                        >
                            {groupBadgeCount}
                        </span>
                    )}
                </div>
                {isOpen && this.populateMenu(menuData)}
            </div>
        );
    };

    render() {
        return (
            <React.Fragment>
                {this.renderGroup("Dashboard", dashboardMenu, "dashboard")}
                {this.renderGroup("Reports", reportsMenu, "reports")}
                {/* {this.renderGroup("Food Delivery App", deliveryAppMenu, "deliveryApp")} */}
                {this.renderGroup("Admin Users", userMgtMenu, "adminUserMgt")}
                {this.renderGroup("Material", materialMgtMenu, "materialMgt")}
                {this.renderGroup("Requests Indent", requestsIntendMenu, "requestsIndent")}
                {this.renderGroup("Outlets", outletsMenu, "outlets")}
                {this.renderGroup("Menu", menu, "menu")}
                {this.renderGroup("Notifications", notificationsMenu, "notifications")}
                {this.renderGroup("Purchase", PurchaseMenu, "purchase")}
                {this.renderGroup("Support & Enquiry", supportMenu, "support")}
                {this.renderGroup("User Levels", userLevelMenu, "userLevels")}
                {this.renderGroup("Content", contentMgtMenu, "content")}
                {this.renderGroup("Coupons & Offers", couponsMenu, "coupons")}
                {this.renderGroup("Subscription", subscriptionMenu, "Subscription")}
                {this.renderGroup("System preference", systemMenu, "system")}
            </React.Fragment>
        );
    }
}

// Map Redux state to component props
const mapStateToProps = (state) => ({
    access: state.login.access,
    userEmail: state.login.email, // Assuming email is stored in state.login.email
    pendingStockRequests: state.stockRequests.pendingStockRequests
});

// Connect component to Redux store and export it
export default connect(mapStateToProps)(Sidebar);